var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.9766 4 4 12.9766 4 24C4 35.0234 12.9766 44 24 44C35.0234 44 44 35.0234 44 24C44 12.9766 35.0234 4 24 4ZM24 8C32.8594 8 40 15.1406 40 24C40 32.0273 34.1289 38.625 26.4375 39.7969V28.7695H31.0938L31.8242 24.0391H26.4375V21.4531C26.4375 19.4883 27.0781 17.7422 28.918 17.7422H31.8711V13.6133C31.3516 13.543 30.2539 13.3906 28.1797 13.3906C23.8477 13.3906 21.3086 15.6797 21.3086 20.8906V24.0391H16.8555V28.7695H21.3086V39.7578C13.7422 38.4805 8 31.9414 8 24C8 15.1406 15.1406 8 24 8Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ff69facc01ad4d716e8a0533f162319f.svg";
export { ForwardRef as ReactComponent };